import { useState, useEffect } from 'react';
import loadImage from 'blueimp-load-image';

function isHTMLImage(data: any): data is HTMLImageElement {
  return typeof data?.src === 'string';
}

export default function useImageLoader(
  file: File | Blob | undefined,
): string | undefined {
  const [loadedImage, setLoadedImage] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!file) return;

    loadImage(
      file,
      newImage => {
        if (isHTMLImage(newImage)) {
          setLoadedImage(newImage.src);
        }
      },
      { orientation: true, noRevoke: true },
    );
  }, [file]);

  return loadedImage;
}
